import React from 'react'

interface ILinkedin {
  width?: string
  height?: string
}

const Linkedin: React.FC<ILinkedin> = ({ width = '26', height = '26' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V26H26V0H0ZM8.08697 21.6001H4.22949V9.99463H8.08697V21.6001ZM6.15823 8.41063H6.13274C4.83874 8.41063 4 7.51914 4 6.40486C4 5.26611 4.86326 4.39989 6.18349 4.39989C7.504 4.39989 8.31549 5.26611 8.34074 6.40486C8.34074 7.51914 7.504 8.41063 6.15823 8.41063ZM22 21.6001H18.1415V15.3911C18.1415 13.8317 17.584 12.7671 16.1875 12.7671C15.121 12.7671 14.4872 13.4839 14.208 14.1782C14.1065 14.4262 14.08 14.7709 14.08 15.1187V21.6002H10.2207C10.2207 21.6002 10.2725 11.0834 10.2207 9.99469H14.08V11.6392C14.5927 10.8502 15.5078 9.72223 17.5575 9.72223C20.0967 9.72223 22 11.3805 22 14.945V21.6001Z"
      fill="#1E2238"
    />
  </svg>
)

export default Linkedin
